var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCocktail(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.57789,
    height: 51.11354,
    viewBox: "0 0 45.57789 51.11354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b1cc33;}.cls-2{fill:#5c9e31;}.cls-3{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-supplement"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.26432,
    y1: 13.89212,
    x2: 36.42418,
    y2: 13.89212
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.93183,
    y1: 13.89212,
    x2: 23.62714,
    y2: 13.89212
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.17251 13.06966 13.1421 19.62944 22.78894 32.36328 32.43579 19.62944 37.40538 13.06966 8.17251 13.06966"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.68791 13.06966 24.71831 19.62944 18.93021 27.26982 22.78894 32.36328 32.43579 19.62944 37.40538 13.06966 29.68791 13.06966"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.78894,
    y1: 32.36335,
    x2: 22.78894,
    y2: 50.11355
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10.44098,
    y1: 50.11355,
    x2: 35.13691,
    y2: 50.11355
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "42.08264 6.89568 32.43579 19.62952 22.78894 32.36335 13.1421 19.62952 3.67932 7.13871"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3.67932,
    y1: 7.13871,
    x2: 3.49525,
    y2: 6.89568
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.10419,
    y1: 16.15665,
    x2: 37.45215,
    y2: 1.49345
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktail);
export default __webpack_public_path__ + "static/media/cocktail.c190eb323eb6040d570dde1210c614c9.svg";
export { ForwardRef as ReactComponent };